export const ALERT_MESSAGE = {
  percentage: "Please enter a percentage that is less than 100%. Full refunds can be selected on the previous page.",
  dollar: "Please enter an amount that is less than the total. Full refunds can be selected on the previous page.",
};

// BBT-2724: tip-only 100% refund is a valid partial refund; unlike sales, no
// Full-Refund alternative exists for tips alone, so the cap is the full tip
// (not full tip minus a cent, which is how the sales-amount field is capped).
export const getAmountOfTipsDollarRules = (order) => [
  { type: "number", min: 0, message: ALERT_MESSAGE.dollar },
  { type: "number", max: order?.tip_cents * 0.01, message: ALERT_MESSAGE.dollar },
];

// BBT-2724: payload for the "Refund Tips Only" entry point. tip_fraction_multiplier=0
// asks the backend to refund 100% of the order's remaining tip; sale_fraction_multiplier=1
// leaves the subtotal alone. Both *_cents_to_add stay 0 so the backend's mode-assertion
// (cents-mode XOR fraction-mode) routes through fraction-mode without ambiguity.
export const buildTipsOnlyRefundPayload = ({ order, idempotencyToken, reason }) => ({
  order_id: order?.orderId,
  idempotency_token: idempotencyToken,
  sale_cents_to_add: 0,
  sale_fraction_multiplier: 1,
  tip_cents_to_add: 0,
  tip_fraction_multiplier: 0,
  reason: reason || "Owner portal refund",
});
